export default __webpack_public_path__ + "static/fax_compare_comp2_active-ea0b4df7314203c9d4854bdca3ed27ce.png";